import React, { useState, useEffect, useRef } from 'react';
import { Container, Row, Col, Label, Input, FormGroup, Spinner } from 'reactstrap';
import PropTypes from 'prop-types';
import { Redirect } from 'react-router-dom';
import _ from 'lodash';
import DatePicker from 'react-datepicker';
import moment from 'moment';
import { isIOS, isMobile } from 'react-device-detect';
import { useDispatch, useSelector } from 'react-redux';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBell, faInfoCircle } from '@fortawesome/free-solid-svg-icons';
import { ToastContainer, toast } from 'react-toastify';
import getFromRef from '../../services/SearchVehicle/getListFromReferential';
import 'react-toastify/dist/ReactToastify.css';
import { t, numStr } from '../common/Translate';
import settingsBlue from '../../assets/img/settings-blue.svg';
import editIcon from '../../assets/img/edit.svg';
import {
  regexRegistration as regexRegRule,
  datesFormat,
  popularBrands,
  popularBrandsItaly,
  decodeVinCountry,
} from '../../config';
import formatRecordData from '../../services/Pricing/formatRecordData';
import ValuationVersions from './ValuationVersions';
import '../../assets/scss/react-datepicker.css';
import { calendarLang } from '../../language-context';
import { Auth, recordActions, recordHandler } from '../../config/configuration/react';
import useRecord from '../../Store/uses/useRecord';
import { versionsListPresenter } from '../../Utils/presenters/vincheck/versionsPresenter';
import { Record } from '../../config/Record/RecordEntity';
import { DefaultAlertModal } from '../common/Modal/DefaultAlertModal';
import { checkIfSelectedDateExist, formatEntryStocksDays } from '../../Store/helpers/pricing';
import VinDecodingEquipmentsModal from '../common/equipment/VinDecodingEquipmentsModal';

const regexRegistration = () => {
  const country = Auth.country();
  return new RegExp(regexRegRule[country] ? regexRegRule[country] : regexRegRule.default);
};

const formFillMode = 'linear'; // can be : "tolerant" || "linear"
const cascade = [
  'makeId',
  'modelId',
  'fuelId',
  'bodyId',
  'doorId',
  'seats',
  'gearId',
  'engineId',
  'liter',
  'versionId',
];

let neededVehicleProperties = [
  'registration',
  'vin',
  'makeId',
  'makeName',
  'modelId',
  'modelName',
  'dateRelease',
  'dateGrayCard',
  'fuelId',
  'fuelName',
  'bodyId',
  'bodyName',
  'doorId',
  'seats',
  'gearId',
  'gearName',
  'engineId',
  'liter',
];

const getCascadePosition = (cursor) => cascade.findIndex((e) => e === cursor);

const FormVehicle = (props) => {
  const {
    vehicle,
    setVehicle,
    setManuelSearch,
    manuelSearch,
    selectMode,
    match,
    className,
    setAlertModal,
    proceedFormCreation,
    setProceedFormCreation,
    checkImmatGCProcess,
    preservedVehicle,
    history,
    entryStockValue,
    entryStockDate,
    getEntryStockDate,
    updateInfoWithVin,
    registration,
    setVersions,
    versions,
    updateInfoLoading,
    isVinDecode,
    manuelSearchVinDecoding,
    blockDecoding,
    setBlockDecoding,
    errors,
    setErrors,
  } = props;
  const enableVinDecodingForUser = Auth.isAllowedToVinDecoding();
  const [isInit, setIsInit] = useState(true);
  const [redirect, setRedirect] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [carEquipment] = useState(vehicle?.equipments || vehicle?.carEquipment || []);
  const { recordId } = match.params;
  const { record: recordData } = useRecord(recordId);
  const [currentSource, setCurrentSource] = useState(recordData?.sourceInfos || null);
  const [showValuationDetails, setShowValuationDetails] = useState(false);
  const [identification, setIdentification] = useState('auto');
  const recordEntity = new Record(recordData);
  const [profile, setProfile] = useState((recordEntity.status() !== 18 && vehicle.profile) || null);
  const country = Auth.country();
  const isUkFile = recordEntity.getCountry() === 'UK';
  let disabled = recordEntity.vehicleIdentityBlocIsNotAllowed() || Auth.roleViewerAccess();
  if (recordEntity.status() !== 18 && country !== 'DE' && !disabled) disabled = true;
  if ((recordEntity.isHBS() || recordEntity.isNrmSolHbs()) && recordEntity.getCountry() !== 'FR' && disabled)
    disabled = recordEntity.editVehicleIdentity() || Auth.roleViewerAccess();
  if (
    recordEntity.status() === 1 &&
    ['PT', 'ES'].includes(country?.toUpperCase()) &&
    recordEntity.isAutobizMarket() &&
    (vehicle.dateGrayCard === null || vehicle.dateGrayCard === undefined)
  ) {
    disabled = false;
  }
  const [showLiter, setShowLiter] = useState(true);
  const isMounted = useRef(false);
  const dispatch = useDispatch();
  const entryStockOptions = useSelector((state) => state.reduxRecords.data[recordId])?.entryStockOption || [];
  let supervisorEntryStockDate = useSelector(
    (state) => state.reduxRecords.data[recordId]?.supervisor?.entryStockDate?.date,
  );
  const originId = useSelector((state) => state?.reduxRecords?.data[recordId]?.record?.originId);
  const countryId = useSelector((state) => state.reduxRecords.data[recordId]?.record?.countryId);
  supervisorEntryStockDate = supervisorEntryStockDate && moment(supervisorEntryStockDate).format('YYYY/MM/DD');
  let showDateOnly = (entryStockDate !== 'select' && moment(entryStockDate).format('DD/MM/YYYY')) || false;
  if (showDateOnly && checkIfSelectedDateExist(entryStockOptions, entryStockValue, showDateOnly)) showDateOnly = false;
  const [isOpen, setIsOpen] = useState(false);
  const [alertModel, setAlertModel] = useState({});
  const [exclusionReason, setExclusionReason] = useState('');
  const [versionPreferred, setVersionPreferred] = useState((versions?.length > 0 && true) || null);
  const recordCountryId = useSelector((s) => s.reduxRecords.data[recordId]?.record?.countryId);
  const recordConfigLevel = useSelector((s) => s.reduxRecords.data[recordId]?.record?.configLevel);
  const [isOpenEquipments, setIsOpenEquipments] = useState(false);
  const getLastValueIndex = () => {
    const l = cascade.length;
    for (let i = l; i >= 0; i--) {
      if (vehicle[cascade[i]]) return cascade.length - 1;
    }
    return 0;
  };
  getLastValueIndex();
  const [cascadeCursor, setcascadeCursor] = useState(cascade[getLastValueIndex()]);
  const [mileage, setMileage] = useState(vehicle.mileage ? vehicle.mileage : null);
  const [mileageForQuotation, setMileageForQuotation] = useState(vehicle.mileage ? vehicle.mileage : null); // use another state here to avoid calculation on each modification
  let isFormComplete = false;
  const appLang = Auth.preferredLanguage().toUpperCase();
  const [configType, setConfigType] = useState(null);
  const [change, setChange] = useState(false);
  const [vehDataChange, setVehDataChange] = useState(false);
  const [initialVin] = useState(vehicle?.vin);
  const [displayInfoText, setDisplayInfoText] = useState(false);
  const versionId = vehicle?.versionId ?? null;
  const versionSelected = versions?.find((version) => version.id === versionId);
  const displayUpdateInfoWithVinDecoding =
    !recordEntity.isNrmRecord() && carEquipment?.some((el) => el.id) && blockDecoding && !updateInfoLoading;
  const isAutoFormConfig =
    recordConfigLevel === 'B' && currentSource?.brand?.configuration
      ? currentSource.brand.configuration.autoFormChoice
      : !!configType;

  if (!currentSource) {
    recordHandler.getSource(recordData?.record?.sourceId, { recordId, countryId: recordCountryId }).then((source) => {
      if (isMounted.current) return;
      setCurrentSource(source);
    });
  } else {
    if (currentSource?.sourceGroupData?.displayTradeInInfos && !showValuationDetails) setShowValuationDetails(true);
    if (configType === null) {
      setConfigType(currentSource?.sourceGroupData?.typeConfigAuto);
    }
  }

  const handleEntryStockChange = (v) => {
    setChange(true);
    getEntryStockDate(v);
  };

  const nextInput = (value) => {
    setChange(true);
    let clonedVehicle = { ...vehicle };
    clonedVehicle = { ...clonedVehicle, ...value };
    setIsInit(false);
    setVehicle(clonedVehicle);
  };

  const updateVehicle = (name, value, manual = false) => {
    setChange(true);
    let clonedVehicle = { ...vehicle };

    if (name === 'versionId' && country === 'NL') {
      let selectedVersion = versions.filter((v) => v.id === value.versionId);
      if (selectedVersion.length > 0) {
        setVersionPreferred(selectedVersion[0]?.preferred);
        if (selectedVersion[0]?.preferred === false) {
          setIsOpen(true);
          setAlertModel({
            body: <div>{t('versionsChange')}</div>,
            cancelBtn: 'no',
            validateBtn: 'yes',
            handleCancel: () => {
              setIsOpen(false);
              selectedVersion = versions.find((v) => v.preferred === true);
              clonedVehicle = {
                ...clonedVehicle,
                ...{ versionId: selectedVersion.id, versionName: selectedVersion.name },
              };
              setVehicle(clonedVehicle);
              setVersionPreferred(true);
            },
            handleValidate: () => setIsOpen(false),
          });
        }
      } else setVersionPreferred(null);
    }

    if (value[name] === '0') {
      delete clonedVehicle[name];
    } else if (clonedVehicle[name] === value[name]) {
      delete clonedVehicle[name];
    } else {
      clonedVehicle = { ...clonedVehicle, ...value };
    }
    if (originId < 10 && countryId === 7) {
      setVehDataChange(true);
    }
    if (getCascadePosition(name) >= 0) {
      cascade.slice(getCascadePosition(name) + 1).forEach((step) => delete clonedVehicle[step]);
      console.log('cascade ', cascade[_.min([getCascadePosition(name) + 1, cascade.length - 1])]);
      if (cascade[_.min([getCascadePosition(name) + 1, cascade.length - 1])] === 'liter' && !showLiter)
        setcascadeCursor(cascade[_.min([getCascadePosition(name) + 2, cascade.length - 1])]);
      else setcascadeCursor(cascade[_.min([getCascadePosition(name) + 1, cascade.length - 1])]);
    }
    if (manual) {
      clonedVehicle.versionType = null;
      clonedVehicle.versions = [];
      setVersions([]);
      delete clonedVehicle._meta;
      delete clonedVehicle.equipments;
    }
    setIsInit(false);
    setVehicle(clonedVehicle);
    if (name !== 'versionId' && clonedVehicle.versions?.length === 0) setIdentification('manuel');
  };

  if (decodeVinCountry.includes(recordEntity.getCountry())) {
    neededVehicleProperties = neededVehicleProperties.filter((key) => key !== 'registration');
  } else if (!neededVehicleProperties.values((i) => i === 'registration'))
    neededVehicleProperties.unshift('registration');

  if (vehicle?.fuelId === 4 && !vehicle?.liter && showLiter) {
    neededVehicleProperties = neededVehicleProperties.filter((key) => key !== 'liter');
    setShowLiter(false);
  } else if (vehicle?.fuelId !== 4 && !neededVehicleProperties.includes('liter')) {
    neededVehicleProperties.push('liter');
    setShowLiter(true);
  }

  isFormComplete = neededVehicleProperties.every((key) => {
    if (
      country === 'NL' &&
      vehicle?.dateGrayCard !== undefined &&
      vehicle?.dateGrayCard !== '' &&
      vehicle?.dateGrayCard !== null &&
      vehicle?.vin !== undefined &&
      vehicle?.vin !== '' &&
      vehicle?.vin !== null
    )
      return true;
    if (recordEntity.status() === 18 && key === 'registration' && selectMode === 'vin' && vehicle[key] === undefined)
      return true;
    if (recordEntity.status() !== 18 && key === 'registration' && !selectMode && !vehicle[key]) return true;
    if (country === 'IT' && vehicle?.dateRelease !== vehicle.dateGrayCard) {
      vehicle.dateGrayCard = vehicle.dateRelease;
      return vehicle.dateGrayCard;
    }
    if (entryStockDate === 'select') return false;
    return vehicle[key];
  });

  const setHistoryChanges = (name, value) => {
    setChange(true);
    const changes = { ...manuelSearch };
    changes[name] = value;
    setManuelSearch(changes);
  };

  const updateMileage = (value) => {
    if (value) {
      setChange(true);
      const v = value.replace(/[^0-9]/g, '');
      if (v.length > 6) return;
      setMileage(v);
    } else setMileage(null);
  };

  const handleChangeDate = (id, value) => {
    const clonedVehicle = { ...vehicle };
    if (value === null || value === undefined || !value) {
      delete clonedVehicle[id];
      setVehicle(clonedVehicle);
      setHistoryChanges(id, null);
    } else {
      const date = moment(value).format('YYYY-MM-DD');
      if (date) clonedVehicle[id] = date;
      setVehicle(clonedVehicle);
      setHistoryChanges(id, date);
    }
  };

  const checkOptionType = (opt) => {
    if (typeof opt === 'string') {
      if (opt.includes('/')) {
        const valueTypeInt = opt.split('/');
        return valueTypeInt[1];
      }
    }
    return opt;
  };

  const checkExclusionsNrm = () => {
    if (recordEntity.isNrmRecord()) {
      const entryStockDays = moment(entryStockDate).format('YYYY-MM-DD');
      let reason = null;
      if (moment(entryStockDays).diff(vehicle.dateRelease, 'months') < 6)
        reason = 'entryStockDaysMinusdateReleaseLessThanSixMonths';
      if (!reason && moment(entryStockDays).diff(vehicle.dateGrayCard, 'months') < 6)
        reason = 'entryStockDaysMinusdateGrayCardLessThanSixMonths';
      if (!reason && !vehicle?.versionId) reason = 'versionIsMandatory';
      if (reason) {
        setExclusionReason(reason);
        setIsOpen(true);
        setIsLoading(false);
        return true;
      }
    }
    setExclusionReason('');
    return false;
  };

  const formatData = async (formProfile) => {
    let veh = _.pick(vehicle, neededVehicleProperties);
    let entryDateReleaseValue = null;
    if (
      vehicle.entryDateRelease !== null &&
      vehicle.entryDateRelease !== '' &&
      vehicle.entryDateRelease !== undefined
    ) {
      entryDateReleaseValue = moment(vehicle.entryDateRelease).format('YYYY-MM-DD');
    }
    veh.seatsLabel = veh.seats;
    veh.seats = checkOptionType(veh.seats);
    veh.dateOfRelease = vehicle.dateRelease;
    veh.mileage = mileage;
    veh.dateOfRelease = veh.dateRelease;
    delete veh.dateRelease;
    veh.versionId = vehicle.versionId;
    veh.versions = vehicle.versionName;
    veh.doors = veh.doorId;
    veh.profile = profile || formProfile;
    veh.kw = _.round(vehicle.engineId / 1.36);
    veh.ps = vehicle.engineId;
    veh = { ...vehicle, ...veh };
    const record = await formatRecordData(veh, currentSource);
    record.recordId = recordId;
    record.color = vehicle.color;
    record.identification = identification;
    record.carTypeId = vehicle.carTypeId;
    record.carTypeLabel = vehicle.carTypeLabel;
    record.cylinderCapacity = vehicle.cylinderCapacity;
    record.co2Emissions = vehicle.co2Emissions;
    record.speedNumber = vehicle.speedNumber || null;
    record.cylinder = vehicle.cylinder || null;
    record.liter = vehicle.liter || null;
    record.emissionStandard = vehicle.emissionStandard || null;
    record.versionsData = JSON.stringify(versions?.slice(vehicle?.versionType === 'vin' ? -10 : 0)) || null;
    record.entryRegistrationDate = entryDateReleaseValue || null;
    record.versionType = vehicle?.versionType || null;
    record.versionSupplier = vehicle?._meta?.supplier || null;
    record.buyerVersionList = vehicle.versionName;
    record.buyerVersionId = vehicle.versionId;
    record.versionOrg = vehicle.orgVersion || null;
    record.carEquipment = vehicle?.equipments?.some((el) => el.id)
      ? JSON.stringify(vehicle?.equipments?.filter((el) => el.id))
      : null;
    if (country === 'NL' && versionPreferred !== null) record.versionPreferred = versionPreferred;
    if (country === 'NL') record.providerId = 1;
    return record;
  };

  const handleExclusion = async () => {
    const record = await formatData(profile);
    setIsOpen(!isOpen);
    await dispatch(recordActions.updateRemoteRecord(recordId, record));
    await dispatch(recordActions.updateStatus(recordId, 'refused'));
    await dispatch(recordActions.updateRecordData(recordId));
    setRedirect(`/files/${recordId}`);
  };

  useEffect(() => {
    setAlertModel({
      body: <div>{`[${t('outOfProcessPopUp')}] [${t(exclusionReason)}]`}</div>,
      cancelBtn: 'close',
      validateBtn: 'modify',
      handleCancel: handleExclusion,
      handleValidate: () => setIsOpen(false),
    });
  }, [exclusionReason]);

  const createNewForm = async (formProfile = null) => {
    setIsLoading(true);
    const record = await formatData(formProfile);
    // carcheck exclustion for nrm record
    if (checkExclusionsNrm()) return;
    if (proceedFormCreation) {
      setAlertModal(false);
      setProceedFormCreation(false);
      setIsLoading(true);
      try {
        await dispatch(recordActions.updateRemoteRecord(recordId, record));
      } catch (err) {
        toast.error(!window.navigator.onLine ? 'Connection issue.' : t('errorMessageCreateVehicle'), {
          position: 'bottom-left',
          autoClose: false,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          theme: 'colored',
        });
        setIsLoading(false);
        return;
      }
      await dispatch(recordActions.updateRecordData(recordId));
      if (supervisorEntryStockDate !== entryStockDate && entryStockValue >= 0 && entryStockDate)
        await dispatch(recordActions.putSupervisorInfos(recordId, { entryStockValue, entryStockDate }));
      if (country === 'NL' && recordEntity.status() === 18)
        await dispatch(recordActions.createExternalProvider(recordId, record));
      const veh = _.pick(vehicle, neededVehicleProperties);
      if (veh?.appraisalLinkedRecord) await recordHandler.postCounterInspection(veh.appraisalLinkedRecord, recordId);
      setIsLoading(false);
      setRedirect(`/files/${recordId}`);
      return;
    }
    // Manual identification or datas changes
    if (
      currentSource?.sourceGroupData?.licensePlatePopUp &&
      recordEntity.status() === 18 &&
      (!preservedVehicle ||
        (preservedVehicle &&
          (preservedVehicle.registration !== vehicle.registration ||
            preservedVehicle.dateGrayCard !== vehicle.dateGrayCard)))
    ) {
      await checkImmatGCProcess();
    } else {
      setProceedFormCreation(true);
    }
    setIsLoading(false);
  };

  useEffect(() => {
    if (proceedFormCreation) createNewForm();
    return () => {
      isMounted.current = true;
    };
  }, [proceedFormCreation]);
  function getValueOrDefault(value, defaultValue) {
    return value !== undefined && value !== null ? value : defaultValue;
  }
  useEffect(() => {
    if (
      enableVinDecodingForUser &&
      (!manuelSearchVinDecoding?.vin ||
        (manuelSearch?.vin && manuelSearch?.vin !== manuelSearchVinDecoding?.vin) ||
        !manuelSearchVinDecoding?.dateRelease ||
        (manuelSearch?.dateRelease && manuelSearch?.dateRelease !== manuelSearchVinDecoding?.dateRelease))
    ) {
      setBlockDecoding(false);
      setErrors((perv) => ({ ...perv, updateWithVinError: null }));
    } else if (enableVinDecodingForUser) {
      setBlockDecoding(true);
      setErrors((perv) => ({ ...perv, updateWithVinError: null }));
    }
  }, [manuelSearch?.vin, manuelSearch?.dateRelease, manuelSearchVinDecoding]);

  let validateVehicleSection = null;
  if (recordEntity.status() === 18 && !Auth.roleViewerAccess()) {
    validateVehicleSection = isAutoFormConfig ? (
      <button
        type="button"
        disabled={!isFormComplete}
        data-test="validateVehicle-btn"
        className={`btn ${isFormComplete ? 'btn-1' : 'btn-4'}`}
        onClick={() => createNewForm()}
      >
        {isLoading && <Spinner size="sm" className="mr-2" />}
        {t('valid_this_vehicle')}
      </button>
    ) : (
      <Row className="footer-sticky-bottom" style={{ marginTop: 0 }}>
        {['light_form', 'full_form'].map((form) => (
          <Col>
            <button
              type="button"
              disabled={!isFormComplete}
              className={`btn btn-block ${isFormComplete ? 'btn-1' : 'btn-4'}`}
              onClick={() => {
                const formProfile = (form === 'light_form' && 'b2b') || 'b2c';
                setProfile(formProfile);
                createNewForm(formProfile);
              }}
            >
              {isLoading && <Spinner size="sm" className="mr-2" />}
              {t(form)}
            </button>
          </Col>
        ))}
      </Row>
    );
  }

  useEffect(() => {
    if (Auth.country() !== 'NL' && versionId && versionSelected && !versionSelected.ref) {
      setDisplayInfoText(true);
    } else {
      setDisplayInfoText(false);
    }
  }, [vehicle.versionId, versions, displayInfoText]);

  return (
    <Container fluid className={`${className} from-vehicle`}>
      <h1 className="h5 text-primary">
        <img src={settingsBlue} className="align-top mr-2" alt="" />
        {t('vehicles_informations')}
      </h1>
      <hr className="primary" />
      <Row>
        {(neededVehicleProperties.includes('registration') || decodeVinCountry.includes(recordEntity.getCountry())) && (
          <Col xs={12} lg={4}>
            <RegistrationInput
              registration={registration}
              vehicle={vehicle}
              setVehicle={setVehicle}
              setHistoryChanges={setHistoryChanges}
              selectMode={selectMode}
              disabled={country === 'NL' && selectMode !== null && vehicle.registration !== '' ? true : disabled}
            />
          </Col>
        )}

        {neededVehicleProperties.includes('vin') && (
          <Col xs={12} lg={4}>
            <VinInput
              vin={vehicle.vin}
              vehicle={vehicle}
              setVehicle={setVehicle}
              setHistoryChanges={setHistoryChanges}
              selectMode={selectMode}
              // disabled={disabled}
              disabled={
                country === 'NL' &&
                selectMode !== null &&
                initialVin !== undefined &&
                initialVin !== '' &&
                initialVin !== null
                  ? true
                  : disabled
              }
            />
          </Col>
        )}

        <Col xs={12} md={6} lg={4}>
          <VehicleProperty
            type="select"
            scope="makes"
            label="makeName"
            name="makeName"
            identifier="makeId"
            filters={vehicle}
            cursor={cascadeCursor}
            value={vehicle.makeId ? vehicle.makeId : 0}
            setFilter={updateVehicle}
            setHistoryChanges={setHistoryChanges}
            setcascadeCursor={setcascadeCursor}
            isInit={isInit}
            dateRelease={vehicle.dateRelease ? vehicle.dateRelease : null}
            // setFilterName={setFilterName}
            identification={identification}
            disabled={disabled}
            isVinDecode={isVinDecode}
            vehDataChange={vehDataChange}
          />
        </Col>
        <Col xs={12} md={6} lg={4}>
          {(vehicle.makeId && (
            <VehicleProperty
              type="select"
              scope="models"
              label="modelName"
              name="modelName"
              identifier="modelId"
              cursor={cascadeCursor}
              filters={vehicle}
              value={vehicle.modelId ? vehicle.modelId : 0}
              setFilter={updateVehicle}
              setHistoryChanges={setHistoryChanges}
              isInit={isInit}
              setcascadeCursor={setcascadeCursor}
              dateRelease={vehicle.dateRelease ? vehicle.dateRelease : null}
              identification={identification}
              disabled={disabled}
              isVinDecode={isVinDecode}
              vehDataChange={vehDataChange}
            />
          )) || (
            <>
              <Label className="alternate">
                {t('modelName')}
                {neededVehicleProperties.includes('modelId') && ' *'}
              </Label>
              <select disabled className="form-control alternate icon-chevron-down unset-bgColor">
                <option>---</option>
              </select>
            </>
          )}
        </Col>
        <Col xs={12} md={6} lg={4}>
          <VehicleProperty
            type="button"
            label="carTypeLabel"
            name="carType"
            identifier="carType"
            cursor={cascadeCursor}
            filters={vehicle}
            value={vehicle?.carTypeLabel ? vehicle?.carTypeLabel : ''}
            setFilter={updateVehicle}
            setHistoryChanges={setHistoryChanges}
            isInit={isInit}
            setcascadeCursor={setcascadeCursor}
            dateRelease={vehicle.dateRelease ? vehicle.dateRelease : null}
            identification={identification}
            disabled
            isVinDecode={isVinDecode}
            vehDataChange={vehDataChange}
          />
        </Col>
        <Col xs={12} md={6} lg={4}>
          <Label className="alternate">
            {t('dateRelease')} {neededVehicleProperties.includes('dateRelease') && ' *'}
          </Label>
          <DatePicker
            className={`alternate icon-calendar ${vehicle.dateRelease ? 'selected' : ''}`}
            name="dateRelease"
            id="dateRelease"
            onChange={(e) => {
              handleChangeDate('dateRelease', e);
            }}
            selected={vehicle.dateRelease ? moment(vehicle.dateRelease).toDate() : ''}
            locale={calendarLang[appLang]}
            dateFormat={appLang === 'DE' ? datesFormat[appLang] : datesFormat.default}
            placeholderText={t('long_date_placeholder')}
            autoComplete="off"
            showMonthDropdown
            showYearDropdown
            yearDropdownItemNumber={10}
            scrollableYearDropdown
            popperModifiers={{
              flip: {
                behavior: ['bottom'], // don't allow it to flip to be above
              },
              preventOverflow: {
                enabled: false, // tell it not to try to stay within the view (this prevents the popper from covering the element you clicked)
              },
              hide: {
                enabled: false, // turn off since needs preventOverflow to be enabled
              },
            }}
            disabled={disabled}
          />
        </Col>
        <Col xs={12} md={6} lg={4}>
          <Label className="alternate">
            {t('dateGrayCard')} {neededVehicleProperties.includes('dateGrayCard') && ' *'}
          </Label>
          <DatePicker
            className={`alternate icon-calendar ${vehicle.dateGrayCard ? 'selected' : ''}`}
            name="dateGrayCard"
            id="dateGrayCard"
            onChange={(e) => {
              handleChangeDate('dateGrayCard', e);
            }}
            selected={vehicle.dateGrayCard ? moment(vehicle.dateGrayCard).toDate() : ''}
            locale={calendarLang[appLang]}
            dateFormat={appLang === 'DE' ? datesFormat[appLang] : datesFormat.default}
            placeholderText={t('long_date_placeholder')}
            autoComplete="off"
            maxDate={new Date()}
            showMonthDropdown
            showYearDropdown
            yearDropdownItemNumber={10}
            scrollableYearDropdown
            popperModifiers={{
              flip: {
                behavior: ['bottom'], // don't allow it to flip to be above
              },
              preventOverflow: {
                enabled: false, // tell it not to try to stay within the view (this prevents the popper from covering the element you clicked)
              },
              hide: {
                enabled: false, // turn off since needs preventOverflow to be enabled
              },
            }}
            disabled={(country === 'IT' && true) || disabled}
          />
        </Col>
        <Col xs={12} md={6} lg={4}>
          <VehicleProperty
            type="selectOrButton"
            scope="fuels"
            label="fuelName"
            name="fuel"
            identifier="fuelId"
            cursor={cascadeCursor}
            filters={vehicle}
            value={vehicle.fuelId ? vehicle.fuelId : 0}
            setFilter={updateVehicle}
            setHistoryChanges={setHistoryChanges}
            isInit={isInit}
            setcascadeCursor={setcascadeCursor}
            dateRelease={vehicle.dateRelease ? vehicle.dateRelease : null}
            identification={identification}
            disabled={disabled}
            checkOptionType={checkOptionType}
            isVinDecode={isVinDecode}
            vehDataChange={vehDataChange}
          />
        </Col>
        <Col xs={12} md={6} lg={4}>
          <VehicleProperty
            type="selectOrButton"
            scope="bodies"
            label="bodyName"
            name="body"
            identifier="bodyId"
            cursor={cascadeCursor}
            filters={vehicle}
            value={vehicle.bodyId ? vehicle.bodyId : 0}
            setFilter={updateVehicle}
            setHistoryChanges={setHistoryChanges}
            isInit={isInit}
            setcascadeCursor={setcascadeCursor}
            dateRelease={vehicle.dateRelease ? vehicle.dateRelease : null}
            identification={identification}
            disabled={disabled}
            isVinDecode={isVinDecode}
            vehDataChange={vehDataChange}
          />
        </Col>
        <Col xs={12} md={6} lg={4}>
          <VehicleProperty
            type="button"
            scope="doors"
            label="doors"
            name="doors"
            identifier="doorId"
            cursor={cascadeCursor}
            filters={vehicle}
            value={vehicle.doorId ? vehicle.doorId : 0}
            setFilter={updateVehicle}
            setHistoryChanges={setHistoryChanges}
            isInit={isInit}
            setcascadeCursor={setcascadeCursor}
            dateRelease={vehicle.dateRelease ? vehicle.dateRelease : null}
            disabled={disabled}
            checkOptionType={checkOptionType}
            nextInput={nextInput}
            isVinDecode={isVinDecode}
            vehDataChange={vehDataChange}
          />
        </Col>
        <Col xs={12} md={6} lg={4}>
          <VehicleProperty
            type="select"
            scope="seats"
            label="seats"
            name="seats"
            identifier="seats"
            cursor={cascadeCursor}
            filters={vehicle}
            value={getValueOrDefault(vehicle.seatsLabel, getValueOrDefault(vehicle.seats, 0))}
            setFilter={updateVehicle}
            setHistoryChanges={setHistoryChanges}
            isInit={isInit}
            setcascadeCursor={setcascadeCursor}
            dateRelease={getValueOrDefault(vehicle.dateRelease, null)}
            identification={identification}
            disabled={disabled}
            checkOptionType={checkOptionType}
            nextInput={nextInput}
            isVinDecode={isVinDecode}
            vehDataChange={vehDataChange}
          />
        </Col>
        <Col xs={12} md={6} lg={4}>
          <VehicleProperty
            type="selectOrButton"
            scope="gears"
            label="gearName"
            name="gear"
            identifier="gearId"
            cursor={cascadeCursor}
            filters={vehicle}
            value={vehicle.gearId ? vehicle.gearId : 0}
            setFilter={updateVehicle}
            setHistoryChanges={setHistoryChanges}
            isInit={isInit}
            setcascadeCursor={setcascadeCursor}
            dateRelease={vehicle.dateRelease ? vehicle.dateRelease : null}
            identification={identification}
            disabled={disabled}
            checkOptionType={checkOptionType}
            isVinDecode={isVinDecode}
            vehDataChange={vehDataChange}
          />
        </Col>
        <Col xs={12} md={6} lg={4}>
          <VehicleProperty
            type="select"
            scope="engines"
            label="engine"
            name="engine"
            identifier="engineId"
            cursor={cascadeCursor}
            filters={vehicle}
            value={vehicle.engineId ? vehicle.engineId : 0}
            setFilter={updateVehicle}
            setHistoryChanges={setHistoryChanges}
            isInit={isInit}
            setcascadeCursor={setcascadeCursor}
            dateRelease={vehicle.dateRelease ? vehicle.dateRelease : null}
            identification={identification}
            disabled={disabled}
            checkOptionType={checkOptionType}
            isVinDecode={isVinDecode}
            vehDataChange={vehDataChange}
          />
        </Col>
        {showLiter && (
          <Col xs={12} md={6} lg={4}>
            <VehicleProperty
              type="select"
              scope="cylinders"
              label="liter"
              name="liter"
              identifier="liter"
              cursor={cascadeCursor}
              filters={vehicle}
              value={vehicle.liter}
              setFilter={updateVehicle}
              setHistoryChanges={setHistoryChanges}
              isInit={isInit}
              setcascadeCursor={setcascadeCursor}
              dateRelease={vehicle.dateRelease ? vehicle.dateRelease : null}
              identification={identification}
              disabled={disabled}
              checkOptionType={checkOptionType}
              isVinDecode={isVinDecode}
              vehDataChange={vehDataChange}
            />
          </Col>
        )}
        <Col xs={12} md={6} lg={4}>
          <Label className="alternate">{t(isUkFile ? 'mileageInMiles' : 'mileage')}</Label>
          <Input
            placeholder="90 000"
            type="text"
            name="mileage"
            id="mileage"
            value={(mileage && numStr(mileage)) || ''}
            className={`alternate ${mileage && 'selected'}`}
            onChange={(e) => updateMileage(e.target.value)}
            onBlur={() => setMileageForQuotation(numStr(mileage))}
            disabled={!!recordEntity.vehicleIdentityBlocIsNotAllowed() || Auth.roleViewerAccess()}
          />
        </Col>
        {showValuationDetails && (
          <ValuationVersions
            mileage={mileageForQuotation}
            dateOfRelease={vehicle.dateOfRelease}
            versions={vehicle?.versions?.length > 0 ? vehicle.versions : versions}
          />
        )}
        <Col xs={12} md={6} lg={4}>
          <Label className="alternate" for="entryStockDays">
            {`${t('entryStockDays')} *`}
          </Label>
          <Input
            type="select"
            name="entryStockDays"
            id="entryStockDays"
            className={`alternate ${entryStockValue !== 'select' && 'selected'}`}
            value={showDateOnly === false ? entryStockValue : showDateOnly}
            onChange={(e) => handleEntryStockChange(e.target.value)}
            disabled={!!recordEntity.vehicleIdentityBlocIsNotAllowed() || Auth.roleViewerAccess()}
          >
            {showDateOnly !== false && (
              <option key={showDateOnly} value={showDateOnly}>
                {showDateOnly}
              </option>
            )}
            <option key="select" value="select">
              {t('selectEntryStockDate')}
            </option>
            {entryStockOptions &&
              formatEntryStocksDays(entryStockOptions).map((i, k) => (
                <option key={i} value={k}>
                  {i}
                </option>
              ))}
          </Input>
        </Col>
        <Col xs={12} md={6} lg={4}>
          {vehicle.makeId && vehicle.modelId && (
            <VehicleProperty
              type="select"
              scope="versions"
              label="versionName"
              name="versions"
              identifier="versionId"
              cursor={cascadeCursor}
              filters={vehicle}
              value={vehicle?.versionId ? vehicle?.versionId : 0}
              setFilter={updateVehicle}
              setHistoryChanges={setHistoryChanges}
              isInit={isInit}
              setcascadeCursor={setcascadeCursor}
              setVersions={setVersions}
              setIdentification={setIdentification}
              dateRelease={vehicle.dateRelease ? vehicle.dateRelease : null}
              identification={identification}
              disabled={!!recordEntity.vehicleIdentityBlocIsNotAllowed() || Auth.roleViewerAccess()}
              checkOptionType={checkOptionType}
              isVinDecode={isVinDecode}
              vehDataChange={vehDataChange}
            />
          )}
        </Col>
        {Auth.country() !== 'NL' && originId < 10 && countryId === 7 && (
          <Col xs={12} md={6} lg={4}>
            {displayInfoText && (
              <>
                {versionSelected?.mcclbp ? (
                  <Row>
                    <Col xs={1} md={1} lg={1}>
                      <FontAwesomeIcon icon={faInfoCircle} size="1x" className="info-icon m-10" />
                    </Col>
                    <Col xs={11} md={11} lg={11}>
                      {' '}
                      <p className="text-primary">{t('mcclbpVersionSelected')}</p>
                    </Col>
                  </Row>
                ) : (
                  <Row>
                    <Col xs={1} md={1} lg={1}>
                      <FontAwesomeIcon icon={faBell} color="red" className="m-10 fa-lg" />
                    </Col>
                    <Col xs={11} md={11} lg={11}>
                      <p className="text-danger">{t('nonQuotedVersionSelected')}</p>
                    </Col>
                  </Row>
                )}
              </>
            )}
          </Col>
        )}

        {enableVinDecodingForUser &&
          recordEntity.status() === 18 &&
          (!displayUpdateInfoWithVinDecoding || recordEntity.isNrmRecord()) && (
            <Col xs={12} md={6} lg={4}>
              <>
                <button
                  type="button"
                  className="btn btn-1 mt-4 btn-block"
                  onClick={() => {
                    setIsInit(true);
                    updateInfoWithVin();
                  }}
                  disabled={!(vehicle.vin && vehicle.dateRelease) || updateInfoLoading || blockDecoding}
                >
                  {t('updateInfoWithVinDecoding')}
                  {updateInfoLoading && <Spinner size="sm" />}
                </button>
                {!(vehicle.vin && vehicle.dateRelease) && (
                  <p className="ml-2 text-danger"> {t('missingInfoVinDecodingAlert')}</p>
                )}
                {errors?.updateWithVinError && <p className="ml-2 text-danger">{errors.updateWithVinError}</p>}
              </>
            </Col>
          )}
        {carEquipment?.some((el) => el.id) && vehicle?.versionType === 'vin' && !recordEntity.isNrmRecord() && (
          <Col xs={12} md={6} lg={4}>
            <button
              type="button"
              className="btn btn-3 mt-4 btn-block"
              disabled={updateInfoLoading}
              onClick={() => setIsOpenEquipments(true)}
            >
              {t('seeEquipment')}
            </button>
          </Col>
        )}
      </Row>

      <div className="form-vehicle-actions">
        {recordEntity.status() !== 18 && (
          <button type="button" className="btn btn-3 mr-2" onClick={() => history.goBack()}>
            {t('close')}
          </button>
        )}
        {recordEntity.status() !== 18 && change && !Auth.roleViewerAccess() && (
          <button
            type="button"
            disabled={!isFormComplete}
            className={`btn ${isFormComplete ? 'btn-1' : 'btn-4'}`}
            onClick={() => createNewForm()}
          >
            {isLoading && <Spinner size="sm" className="mr-2" />}
            {t('validAfterEdit')}
          </button>
        )}
        {validateVehicleSection}
      </div>

      {redirect && <Redirect from="/" exact to={redirect} />}
      {vehicle?.versionType === 'vin' && carEquipment?.some((el) => el.id) && isOpenEquipments && (
        <VinDecodingEquipmentsModal
          isOpen={isOpenEquipments}
          setIsOpen={setIsOpenEquipments}
          equipments={carEquipment?.filter((el) => el.id) || []}
        />
      )}
      <ToastContainer />
      {isOpen && (
        <DefaultAlertModal
          {...alertModel}
          isOpen={isOpen}
          toggle={() => {
            setIsOpen(!isOpen);
            setIsLoading(false);
          }}
          size="md"
          centered
        />
      )}
    </Container>
  );
};

FormVehicle.propTypes = {
  vehicle: PropTypes.shape().isRequired,
  setVehicle: PropTypes.func.isRequired,
  setManuelSearch: PropTypes.func.isRequired,
  manuelSearch: PropTypes.shape().isRequired,
  selectMode: PropTypes.string,
  match: PropTypes.shape().isRequired,
  className: PropTypes.string.isRequired,
  setAlertModal: PropTypes.func.isRequired,
  proceedFormCreation: PropTypes.bool.isRequired,
  setProceedFormCreation: PropTypes.func.isRequired,
  checkImmatGCProcess: PropTypes.func.isRequired,
  preservedVehicle: PropTypes.shape(),
  history: PropTypes.shape().isRequired,
  entryStockValue: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  entryStockDate: PropTypes.string.isRequired,
  getEntryStockDate: PropTypes.func.isRequired,
  registration: PropTypes.string.isRequired,
  updateInfoWithVin: PropTypes.func.isRequired,
  versions: PropTypes.arrayOf(PropTypes.object).isRequired,
  setVersions: PropTypes.func.isRequired,
  updateInfoLoading: PropTypes.bool.isRequired,
  isVinDecode: PropTypes.string.isRequired,
  manuelSearchVinDecoding: PropTypes.shape().isRequired,
  blockDecoding: PropTypes.bool.isRequired,
  setBlockDecoding: PropTypes.func.isRequired,
  errors: PropTypes.shape().isRequired,
  setErrors: PropTypes.func.isRequired,
};

FormVehicle.defaultProps = {
  selectMode: null,
  preservedVehicle: null,
};

export default FormVehicle;

const VehicleProperty = (props) => {
  const recordId = useSelector((state) => state.reduxRecords?.currentRecord);
  const record = useSelector((state) => state?.reduxRecords?.data[recordId]?.record);
  const originId = useSelector((state) => state?.reduxRecords?.data[recordId]?.record?.originId);
  const countryId = useSelector((state) => state.reduxRecords.data[recordId]?.record?.countryId);
  const [isLoading, setIsLoading] = useState(false);
  const [isError, setIsError] = useState(false);
  let { type, filters } = props;
  const { kw } = filters;
  // const { value, identification } = props;
  const { value } = props;
  const {
    name,
    scope,
    cursor,
    identifier,
    label,
    setHistoryChanges,
    setFilter,
    setcascadeCursor,
    isInit,
    setVersions,
    dateRelease,
    disabled: disable,
    checkOptionType,
    nextInput,
    setIdentification,
    isVinDecode,
    vehDataChange,
  } = props;
  const [selection, setSelection] = useState(filters[identifier]);
  const [options, setOptions] = useState([]);
  const country = Auth.country();

  const [initialVersion, setInitialVersion] = useState();
  useEffect(() => {
    const refVersionExist = options?.some((option) => option.ref === true);
    const mcclbpVersionExist = options?.some((option) => option.ref === false && option.mcclbp === true);
    const nonQuotedVersionExist = options?.some((option) => option.ref === false && option.mcclbp === false);

    if (refVersionExist) {
      setInitialVersion(t('VersionRef'));
    } else if (!refVersionExist && mcclbpVersionExist) {
      setInitialVersion(t('VersionMcclbp'));
    } else if (!refVersionExist && !mcclbpVersionExist && nonQuotedVersionExist) {
      setInitialVersion(t('VersionNonQuoted'));
    } else {
      setInitialVersion('');
    }
  }, [options, setInitialVersion, Auth.preferredLanguage()]);

  let initLabel = '';
  if (value && label && options?.length === 0 && type !== 'date') {
    type = 'init';
    initLabel = label === 'seats' ? value : filters[label];
  }

  if (name === 'versions') {
    type = 'select';
    initLabel = filters.versionList;
  }

  if (name === 'modelName' && selection && isVinDecode.current === 'false') {
    const res = options.filter((opt) => opt.id === parseInt(selection, 10));
    if (res[0]?.carType !== undefined && filters.carTypeLabel !== res[0]?.carType) {
      setFilter('carTypeId', {
        carTypeId: res[0]?.carType === 'PARTICULAR' ? 1 : 7,
        carTypeLabel: res[0]?.carType,
      });
    }
  }
  if (name === 'carType' && _.get(filters, 'carTypeLabel', '') === '') {
    type = 'init';
    initLabel = filters.vehicleType?.name;
  }
  // if (options === optionsAAA) {
  //   type = "versionInit";
  // }

  // filter only with higher element in cascade hierarchie
  const identifierPosition = getCascadePosition(identifier);
  const higherEntries = _.slice(cascade, 0, identifierPosition);
  higherEntries.push('dateOfRelease');
  const decodeVersions = filters.versions;
  filters = _.pick(filters, higherEntries);
  const disabled = identifierPosition > getCascadePosition(cursor);

  const clonedFilters = {};
  clonedFilters.kw = kw;

  const setOptionsAvailable = (optionsAvailable) => {
    let optionsList = optionsAvailable;
    if (identifier === 'seats') {
      optionsList.forEach((opt, key) => {
        if (typeof opt.name === 'string' && (opt.name.includes('/') || opt.name.includes('+')))
          optionsList[key].id = opt.name;
      });
    } else if (identifier === 'liter') {
      optionsList = _.unionBy(optionsList, 'liter');
      optionsList.forEach((opt, key) => {
        optionsList[key].cylinderCapacity = opt.id;
        optionsList[key].id = opt.liter;
        optionsList[key].name = opt.liter;
      });
    }
    if (
      // !value &&
      optionsList?.length === 1 &&
      optionsList[0] !== undefined &&
      (!filters[identifier] || filters[identifier] !== optionsList[0].id) &&
      isVinDecode.current === 'false'
    ) {
      if (identifier === 'liter') {
        setFilter(identifier, {
          cylinderCapacity: optionsList[0].cylinderCapacity,
          [label]: optionsList[0].name,
        });
      } else {
        setFilter(identifier, {
          [identifier]: optionsList[0].id,
          [label]: optionsList[0].name,
        });
      }
    }
    setOptions(optionsList);
    const selectionIndex = _.findIndex(options, (o) => o.id === selection);
    if (selectionIndex >= 0 && isVinDecode?.current === 'false') {
      setSelection(selection);
      setFilter(identifier, {
        [identifier]: options[selectionIndex].id,
        [label]: options[selectionIndex].name,
      });
      setHistoryChanges(name, parseInt(selection, 10));
      //   setFilterName(filterName, options[selectionIndex].name);
    }
  };

  const updateOptions = () => {
    if (scope) {
      setIsLoading(true);
      // Send only the previous filters
      Object.entries(filters).forEach(([key]) => {
        if (getCascadePosition(key) < identifierPosition && !key.includes('Name')) {
          clonedFilters[key] = filters[key];
        }
        if (checkOptionType && key === 'seats' && checkOptionType(clonedFilters[key]))
          clonedFilters[key] = checkOptionType(clonedFilters[key]);
      });
      if (dateRelease) clonedFilters.dateOfRelease = dateRelease;
      if (name === 'versions' && decodeVersions?.length > 0 && vehDataChange === false)
        setOptionsAvailable(decodeVersions);
      else if (country !== 'NL') {
        getFromRef(clonedFilters, scope, record)
          .then((result) => {
            if (result !== false) {
              setOptionsAvailable(result);
              if (name === 'versions') {
                setVersions(result);
                setIdentification('manuel');
              }
            }
            setIsError(false);
          })
          .catch(() => {
            neededVehicleProperties = neededVehicleProperties.filter((key) => ![identifier, label].includes(key));
            if (nextInput) {
              nextInput({
                [identifier]: null,
                [label]: null,
              });
            }
            setIsError(true);
          });
      }
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (formFillMode === 'linear') {
      if (
        (isInit && type === 'init') || // type === "versionInit")) ||
        identifierPosition > getCascadePosition(cursor)
      ) {
        return;
      }
    }
    updateOptions();
  }, [JSON.stringify(filters)]);

  let input = '';
  if (type === 'date') {
    input = (
      <Input
        name={identifier}
        id={identifier}
        className={`alternate icon-calendar ${value ? 'selected' : ''}`}
        defaultValue={value}
        onBlur={(e) => {
          setHistoryChanges(name, e.target.value);
          setFilter(identifier, { [identifier]: e.target.value });
        }}
        type="date"
      />
    );
  } else {
    let customOptions = [...options];

    if (identifier === 'versionId') customOptions = versionsListPresenter(customOptions, record);
    if (identifier === 'makeId') {
      const isItaly = countryId === 3;

      const selectedPopularBrands = isItaly ? popularBrandsItaly : popularBrands;
      const popularBrandsIds = _(selectedPopularBrands).map('id').value();

      customOptions = _.filter(customOptions, (o) => !popularBrandsIds.includes(o.id));
      selectedPopularBrands.forEach((brand) => {
        customOptions.unshift(brand);
      });
    }

    const select = (
      <Input
        type="select"
        name={identifier}
        id={identifier}
        className={`alternate icon-chevron-down ${value ? 'selected' : ''}`}
        disabled={isLoading || disable}
        value={value}
        onChange={(e) => {
          setSelection(e.target.value);
          isVinDecode.current = 'false';
          const optionIndex = _.findIndex(customOptions, (o) => {
            if ((identifier === 'seats' && e.target.value.includes('/')) || e.target.value.includes('+'))
              return o.id === e.target.value;
            if (identifier === 'liter') return o.id.toString() === e.target.value;
            return o.id === parseInt(e.target.value, 10);
          });
          if (identifier === 'liter' && optionIndex >= 0) {
            setFilter(identifier, {
              cylinderCapacity: customOptions[optionIndex].cylinderCapacity,
              [label]: optionIndex >= 0 ? customOptions[optionIndex].name : null,
            });
          } else if (identifier !== 'liter' && identifier !== 'versionId') {
            setFilter(
              identifier,
              {
                [identifier]: parseInt(e.target.value, 10),
                [label]: optionIndex >= 0 ? customOptions[optionIndex].name : null,
              },
              true,
            );
          } else {
            setFilter(identifier, {
              [identifier]: parseInt(e.target.value, 10),
              [label]: optionIndex >= 0 ? customOptions[optionIndex].name : null,
            });
          }
          setHistoryChanges(name, parseInt(e.target.value, 10));
        }}
      >
        <option value="0">---</option>
        {originId < 10 && countryId === 7 && identifier === 'versionId' && (
          <optgroup style={{ textTransform: 'none' }} label={initialVersion} />
        )}
        {customOptions.map((opt) => {
          let option = {};
          if (disabled || opt === undefined) {
            option.id = '0';
            option.name = '---';
          } else {
            option = opt;
          }
          return option.id < 0 ? (
            <>
              {' '}
              <option disabled key={option.id}>
                ----------------------------------------------
              </option>
              {originId < 10 && countryId === 7 && identifier === 'versionId' && (
                <optgroup
                  style={{ textTransform: 'none' }}
                  label={option.id === -1 ? t('VersionMcclbp') : t('VersionNonQuoted')}
                />
              )}
            </>
          ) : (
            <React.Fragment key={option.id}>
              <option value={option.id}>{option.name}</option>
              {isMobile && isIOS && <optgroup label="" />}
            </React.Fragment>
          );
        })}
      </Input>
    );

    const button = options.map((opt) => {
      let option = {};
      if (disabled || opt === undefined) {
        option.id = '0';
        option.name = '---';
      } else {
        option = opt;
      }
      return (
        <button
          type="button"
          key={option.id}
          className={`btn alternate flex-fill mb-3 ${value === option.id ? 'selected' : ''}`}
          onClick={() => {
            if (value === option.id) return;
            setSelection(option.id);
            setFilter(
              identifier,
              {
                [identifier]: parseInt(option.id, 10),
                [label]: option.name,
              },
              true,
            );
            setHistoryChanges(name, parseInt(option.id, 10));
            // setFilterName(filterName, e.target.innerHTML);
          }}
        >
          {option.name}
        </button>
      );
    });

    const validateButton = (
      <>
        <button type="button" key="value" className="btn alternate flex-fill mb-3 selected">
          {t(initLabel)}
        </button>
        {disable === false && name !== 'versions' && country !== 'NL' && (
          <button
            type="button"
            key="edit"
            className="btn alternate flex-fill mb-3 edit"
            onClick={() => {
              setcascadeCursor(identifier);
              updateOptions();
            }}
          >
            <img src={editIcon} alt="" className="edit-icon" />
          </button>
        )}
      </>
    );

    switch (type) {
      default:
      case 'selectOrButton':
        if (options.length <= 3) {
          input = button;
        } else {
          input = select;
        }
        break;

      case 'select':
        input = select;
        break;

      case 'button':
        input = button;
        break;

      case 'init':
        input = validateButton;
        break;
    }
  }

  if (disabled || input.length === 0) {
    input = (
      <Input
        type="select"
        name={identifier}
        id={identifier}
        disabled
        className="alternate icon-chevron-down unset-bgColor"
      >
        <option value="0">---</option>
      </Input>
    );
  }

  return (
    <>
      <Label className="alternate">
        {t(name)}
        {country !== 'NL' && neededVehicleProperties.includes(identifier) && ' *'}
        {country !== 'NL' && neededVehicleProperties.includes(identifier) && !value && !disabled && (
          <small className="ml-2 text-lowercase text-danger">{t('mandatory_field')}</small>
        )}
      </Label>
      <FormGroup className="d-flex mb-0 buttons-wrapper">
        {isError ? (
          <select className="alternate" disabled>
            <option>---</option>
          </select>
        ) : (
          <>{input}</>
        )}
      </FormGroup>
    </>
  );
};

VehicleProperty.propTypes = {
  type: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  scope: PropTypes.string,
  cursor: PropTypes.string.isRequired,
  identifier: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  setHistoryChanges: PropTypes.func.isRequired,
  setFilter: PropTypes.func.isRequired,
  setcascadeCursor: PropTypes.func.isRequired,
  isInit: PropTypes.bool.isRequired,
  setVersions: PropTypes.func,
  dateRelease: PropTypes.string.isRequired,
  value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
  filters: PropTypes.shape().isRequired,
  // identification: PropTypes.string,
  disabled: PropTypes.bool.isRequired,
  checkOptionType: PropTypes.func,
  nextInput: PropTypes.func,
  setIdentification: PropTypes.func.isRequired,
  isVinDecode: PropTypes.string.isRequired,
  vehDataChange: PropTypes.bool.isRequired,
};

VehicleProperty.defaultProps = {
  setVersions: () => {},
  // identification: '',
  checkOptionType: () => {},
  scope: undefined,
  nextInput: () => {},
};

const VinInput = ({ setVehicle, setHistoryChanges, vehicle, selectMode, vin: scopeVin, disabled }) => {
  const [vin, setVin] = useState(scopeVin);
  const [isVinError, setIsVinError] = useState(false);

  useEffect(() => {
    setIsVinError(false);
    // if (!vin || vin === '') return;
    const regexVIN = new RegExp('^[a-zA-Z0-9]{17}$');
    if (!regexVIN.test(vin)) {
      if (vin?.length > 17) setIsVinError('vinMoreThan17');
      if (vin?.length < 17) setIsVinError('vinLessThan17');
      if (vehicle?.vin) setVehicle((v) => _.omit(v, 'vin'));
      return;
    }
    setVehicle((v) => ({ ...v, vin }));
  }, [vin]);

  return (
    <>
      <Label className="alternate">
        {t('vin')}
        {neededVehicleProperties.includes('vin') && ' *'}
        <small className="ml-2 text-lowercase text-danger">{t(isVinError)}</small>
      </Label>
      <FormGroup className="d-flex mb-0 buttons-wrapper">
        <Input
          name="vin"
          id="vin"
          type="text"
          value={vin}
          placeholder="XXXXZ03AH55354925"
          className={'btn ' && vin && !isVinError ? 'alternate selected' : 'alternate'}
          onChange={(e) => {
            setHistoryChanges('vin', e.target.value);
            setVin(e.target.value);
          }}
          disabled={disabled ? 'disabled' : ''}
        />
        {disabled === false && selectMode === 'registration' && vin ? (
          <button type="button" key="edit" className="btn alternate flex-fill mb-3 edit" onClick={() => setVin(null)}>
            <img src={editIcon} alt="" className="edit-icon" />
          </button>
        ) : (
          ''
        )}
      </FormGroup>
    </>
  );
};

VinInput.propTypes = {
  setVehicle: PropTypes.func,
  setHistoryChanges: PropTypes.func.isRequired,
  vehicle: PropTypes.shape().isRequired,
  selectMode: PropTypes.string,
  vin: PropTypes.string.isRequired,
  disabled: PropTypes.bool.isRequired,
};

VinInput.defaultProps = {
  setVehicle: () => {},
  selectMode: null,
};

const RegistrationInput = ({ setVehicle, setHistoryChanges, vehicle, selectMode, registration: reg, disabled }) => {
  const [registration, setRegistration] = useState(reg);
  const [isRegistrationError, setIsRegistrationError] = useState(false);

  useEffect(() => {
    setIsRegistrationError(false);
    if (!registration || registration === '') return;
    const cleanedRegistration = registration.replace(/[^a-zA-Z^0-9]/g, '');
    if (!regexRegistration().test(cleanedRegistration)) {
      setIsRegistrationError('registration_dont_match');
      if (vehicle.registration) setVehicle((v) => _.omit(v, 'registration'));
      return;
    }
    setVehicle((v) => ({ ...v, registration: cleanedRegistration }));
  }, [registration]);

  return (
    <>
      <Label className="alternate">
        {t('registration')}
        {neededVehicleProperties.includes('registration') && ' *'}
        <small className="ml-2 text-lowercase text-danger">{t(isRegistrationError)}</small>
      </Label>
      <FormGroup className="d-flex mb-0 buttons-wrapper">
        <Input
          name="registration"
          id="registration"
          type="text"
          value={registration || vehicle?.registration}
          placeholder={t('registration_placeholder')}
          className={registration && !isRegistrationError ? 'alternate selected' : 'alternate '}
          onChange={(e) => {
            setHistoryChanges('registration', e.target.value);
            setRegistration(e.target.value);
          }}
          disabled={disabled ? 'disabled' : ''}
        />
        {selectMode === 'vin' && registration ? (
          <button
            type="button"
            key="edit"
            className="btn alternate flex-fill mb-3 edit"
            onClick={() => setRegistration(null)}
          >
            <img src={editIcon} alt="" className="edit-icon" />
          </button>
        ) : (
          ''
        )}
      </FormGroup>
    </>
  );
};

RegistrationInput.propTypes = {
  setVehicle: PropTypes.func,
  setHistoryChanges: PropTypes.func.isRequired,
  vehicle: PropTypes.shape().isRequired,
  selectMode: PropTypes.string,
  registration: PropTypes.string.isRequired,
  disabled: PropTypes.bool.isRequired,
};

RegistrationInput.defaultProps = {
  setVehicle: () => {},
  selectMode: null,
};
